import { ElementType, HTMLProps, MouseEventHandler, ReactNode, useCallback } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
export type LinkProps<T = HTMLProps<HTMLSpanElement>> = Omit<T, keyof RouterLinkProps> &
  Omit<RouterLinkProps, 'to'> & {
    to?: RouterLinkProps['to'];
    children?: ReactNode;
    fallbackAs?: ElementType;
    preventDefault?: boolean;
    stopPropagation?: boolean;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    disabled?: boolean;
  };
export function Link<T = HTMLProps<HTMLSpanElement>>({
  fallbackAs: FallbackAs = 'span',
  children,
  to,
  preventDefault,
  stopPropagation,
  onClick,
  replace,
  disabled = false,
  ...rest
}: LinkProps<T>) {
  const onLinkClick: MouseEventHandler<HTMLAnchorElement> = useCallback(
    (e) => {
      preventDefault && e.preventDefault();
      stopPropagation && e.stopPropagation();
      onClick?.(e);
    },
    [preventDefault, stopPropagation, onClick]
  );
  if (to && !disabled) {
    return (
      <RouterLink to={to} replace={replace} {...rest} onClick={onLinkClick}>
        {children}
      </RouterLink>
    );
  } else {
    return (
      <FallbackAs disabled={disabled} {...rest}>
        {children}
      </FallbackAs>
    );
  }
}
